export default __webpack_public_path__ + "static/media/aveBehdasht.61bd58d2.jpeg";